import { render, staticRenderFns } from "./ServentiaAcessGroups.vue?vue&type=template&id=e703fba4&"
import script from "./ServentiaAcessGroups.vue?vue&type=script&lang=js&"
export * from "./ServentiaAcessGroups.vue?vue&type=script&lang=js&"
import style0 from "./ServentiaAcessGroups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports